import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { PayloadAction } from "redux-starter-kit";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { Alert, Button } from "@amzn/awsui-components-react-v3";
import { RootState } from "../redux/rootReducer";
import bannerSlice, { DisplayBanner } from "./bannerSlice";
import bannerComponent from "../common/bannerComponent";

interface BannerStateProps {
  displayBanner: DisplayBanner | undefined;
}

interface BannerDispatchProps {
  setBanner: (banner: DisplayBanner | undefined) => void;
  onButtonClick: (action: PayloadAction | undefined) => void;
}

type BannerProps = BannerStateProps & BannerDispatchProps & RouteComponentProps;

const Banner: React.FC<BannerProps> = ({
  displayBanner,
  setBanner,
  history,
  onButtonClick,
}): JSX.Element => {
  useEffect(() => {
    const unlisten = history.listen(() => {
      setBanner(undefined);
    });
    return () => {
      setBanner(undefined);
      unlisten();
    };
  }, [history, setBanner]);

  return (
    <React.Fragment>
      {displayBanner && (
        <Alert
          type={displayBanner.type}
          dismissible={displayBanner.dissmissible}
          header={displayBanner.header}
          onDismiss={() => {
            setBanner(undefined);
          }}
          action={
            displayBanner.buttonText && (
              <Button
                onClick={() => {
                  onButtonClick(displayBanner.onButtonClick);
                }}
              >
                {displayBanner.buttonText}
              </Button>
            )
          }
        >
          {displayBanner.componentId
            ? bannerComponent(displayBanner.componentId)
            : displayBanner.content}
        </Alert>
      )}
    </React.Fragment>
  );
};

const mapStateToProperties = ({ banner }: RootState): BannerStateProps => {
  return {
    displayBanner: banner.displayBanner,
  };
};

const mapDispatchToProperties = (dispatch: Dispatch): BannerDispatchProps => {
  return {
    setBanner: (banner: DisplayBanner | undefined) => {
      dispatch(bannerSlice.actions.setBanner(banner));
    },
    onButtonClick: (action: PayloadAction | undefined) => {
      if (action) {
        dispatch(action);
      }
    },
  };
};

export default withRouter(
  connect(mapStateToProperties, mapDispatchToProperties)(Banner)
);
